function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import _ from 'underscore';
import { Col, Container, Row } from 'reactstrap';
import { createHashHistory } from 'history';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
import entityComposition from '../../common/classes/entityComposition';
import ListPanel from '../../common/containers/listPanel';
import ContractSpecsFilters from './contractSpecsFilters';
import ContractSpecsPagingTable from './contractSpecsPagingTable';
import ContractSpecsRow from './contractSpecsRow';
const hashHistory = createHashHistory();
const handleContractSpecSelect = id => {
  hashHistory.replace(`/admin/contractSpecs/${id}`);
};
class ContractSpecs extends Component {
  constructor(props) {
    super(props);
    const {
      contractSpecActions,
      contractSpec
    } = props;
    contractSpecActions.serverIndex(contractSpec.indexQuery);
    this.filterChange = this.filterChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.filterSearch = text => this.filterChange('text', text);
    this.filterSearchClear = () => this.filterChange('text', '');
    this.filterClear = () => contractSpecActions.serverIndex(contractSpec.initialIndexQuery);
  }
  componentDidMount() {
    const {
      canView,
      location
    } = this.props;
    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
  }
  filterChange(prop, value) {
    const {
      contractSpec,
      contractSpecActions
    } = this.props;
    const newFilters = _objectSpread(_objectSpread({}, contractSpec.indexQuery.filters), {}, {
      [prop]: value
    });
    contractSpecActions.serverFilter(newFilters, contractSpec.indexQuery);
  }
  handleAdd() {
    const {
      contractSpec,
      login,
      contractSpecActions
    } = this.props;
    const csID = uuidV4().toUpperCase();
    const currentCombos = contractSpec.list.map(cs => ({
      jobID: cs.jobID,
      phaseID: cs.phaseID
    }));

    // @TODO https://www.pivotaltracker.com/story/show/167580020
    // iPad sets default units (mils/microns and f/c) by region
    // Web app should mirror that behavior
    const defaultData = {
      active: 1,
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: login.user.user_id,
      dryFilms: [],
      jobAndPhaseCombinations: currentCombos,
      roughnessUnits: 0,
      saltTests: [],
      tempUnits: 0,
      wetFilmThicknessUnits: 0
    };
    contractSpecActions.create(csID, defaultData);
    handleContractSpecSelect(csID);
  }
  render() {
    const {
      contractSpec,
      canEdit
    } = this.props;
    const rows = contractSpec.list.map((cs, index) => /*#__PURE__*/React.createElement(ContractSpecsRow, {
      id: cs.id,
      index: index,
      key: `CS_${cs.id}`,
      data: cs,
      onClick: handleContractSpecSelect,
      hasActions: canEdit
    }));
    const filterProps = {
      filters: contractSpec.indexQuery.filters,
      onFilter: this.filterChange,
      onFilterClear: this.filterClear,
      onSearch: this.filterSearch,
      onSearchClear: this.filterSearchClear
    };
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(ContractSpecsFilters, filterProps)), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      onAdd: this.handleAdd,
      showNew: canEdit,
      title: "Contract Specs"
    }, /*#__PURE__*/React.createElement(ContractSpecsPagingTable, {
      headers: ['Job Number', 'Phase'],
      loading: contractSpec.loading,
      hideSortOptions: true,
      indexQuery: contractSpec.indexQuery
    }, rows)))));
  }
}
ContractSpecs.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  contractSpec: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({}),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }).isRequired,
      sortAttribute: PropTypes.string,
      sortDirection: PropTypes.string
    }),
    initialIndexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  contractSpecActions: PropTypes.shape({
    create: PropTypes.func,
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  login: PropTypes.shape({
    user: PropTypes.shape({
      user_id: PropTypes.string
    })
  }).isRequired
};
export { ContractSpecs as TestContractSpecs };
export default entityComposition(ContractSpecs, ['contractSpec', 'login'], {
  canView: state => viewPermissionSelector('job')(state),
  canEdit: state => editPermissionSelector('job')(state)
});